import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { resetModal } from "../../state/actions/modalAction";
import alertIcon from "../../assets/images/error-icon.png";
import DisconnectPopUpProps from "./DisconnectPopUpProps";
import "./DisconnectPopUp.scss";

const DisconnectPopUp = (props: DisconnectPopUpProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  const closeModal = () => {
    dispatch(resetModal());
  };

  return (
    <div className="otp-error-container">
      <img src={alertIcon} alt="alert" />
      <span id="dialogTitle" className="otp-error-failed-label">
        {t("disconnectPopUp.disconnectLabel")}
      </span>
      {/* <span className="otp-error-try-again">{t("idle.subLabel")}</span> */}

      <div className="btn-group">
        <button
          className="disconnect-btn"
          onClick={() => {
            props.callbackDisconnect();
          }}
        >
          {t("disconnectPopUp.btnOk")}
        </button>
        <button className="disconnect-btn-no" onClick={closeModal}>
          {t("disconnectPopUp.btnNot")}
        </button>
      </div>
    </div>
  );
};

export default DisconnectPopUp;
